"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _modalScreen = _interopRequireDefault(require("./modal-screen"));

var _filterSection = _interopRequireDefault(require("./filter-section"));

var _dataTable = _interopRequireDefault(require("./data-table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SelectionBrowser =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectionBrowser, _Component);

  function SelectionBrowser(props) {
    var _this;

    _classCallCheck(this, SelectionBrowser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectionBrowser).call(this, props));
    _this.state = {
      size: "l",
      showModal: false,
      data: _this.props.data,
      selected: [],
      originalData: _this.props.data
    };
    return _this;
  }

  _createClass(SelectionBrowser, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: "showModal",
    value: function showModal() {
      var _this2 = this;

      this.setState({
        showModal: true,
        data: this.state.originalData
      }, function () {
        var selectedIds = [];

        _this2.state.selected.forEach(function (item, index) {
          selectedIds.push(item.id - 1);
        });

        _this2.table.setSelectedItems(selectedIds);
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      return this.state.selected;
    }
  }, {
    key: "getMultiple",
    value: function getMultiple() {
      if (this.state.selected && this.state.selected.length) {
        var items = [];

        for (var i = 0; i < this.state.selected.length; i++) {
          items.push(this.state.selected[i].selectionDisplay);
        }

        return items.toString();
      } else {
        return "";
      }
    }
  }, {
    key: "selectMultiple",
    value: function selectMultiple() {
      var selected = this.table.getSelectedItems();
      this.setState({
        selected: selected,
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("div", null, this.state.showModal ? _react.default.createElement(_modalScreen.default, {
        title: "Select item",
        primaryMethod: function primaryMethod() {
          return _this3.selectMultiple();
        },
        primaryButtonTitle: "Select",
        secondaryMethod: function secondaryMethod() {
          return _this3.hideModal();
        },
        secondaryButtonTitle: "Cancel",
        modalType: this.state.size,
        closeMethod: function closeMethod() {
          return _this3.hideModal();
        }
      }, _react.default.createElement("div", null, this.props.showFilters ? _react.default.createElement("div", null, _react.default.createElement(_filterSection.default, {
        data: this.props.filters,
        applyAction: function applyAction() {
          return _this3.props.apply();
        },
        clearAction: function clearAction() {
          return _this3.props.clear();
        },
        ref: this.props.filterRef
      }), _react.default.createElement("br", null)) : "", _react.default.createElement(_dataTable.default, {
        data: this.state.data,
        columns: this.props.columns,
        subColumns: this.props.subColumns,
        isSelectable: true,
        selectedOption: this.props.selectedOption,
        isSortable: this.props.isSortable,
        isResizable: this.props.isResizable,
        isEditable: false,
        hasFooter: false,
        isExpandable: this.props.isExpandable,
        manualPagination: this.props.manualPagination,
        showPagination: this.props.showPagination,
        showColumnOptions: this.props.showColumnOptions,
        tableName: this.props.tableName,
        ref: function ref(table) {
          return _this3.table = table;
        },
        actions: this.props.actions,
        statusOptions: this.props.statusOptions
      }))) : "", _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, this.props.label), _react.default.createElement("div", {
        className: "input-btn-wrapper",
        onClick: function onClick() {
          return _this3.showModal();
        }
      }, _react.default.createElement("input", {
        className: "form-control",
        type: "text",
        readOnly: true,
        value: this.getMultiple()
      }), _react.default.createElement("button", {
        type: "button",
        className: "select-btn"
      }, _react.default.createElement("span", {
        className: "fa fa-folder-open"
      })))));
    }
  }]);

  return SelectionBrowser;
}(_react.Component);

var _default = SelectionBrowser;
exports.default = _default;